import { createRoute } from '@tanstack/react-router';
import { VozidlaList } from '@/modules/vozidla/VozidlaList';
import { parseVozidlaSearch } from '@/modules/vozidla/helpers';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla',
  component: VozidlaList,
  validateSearch: parseVozidlaSearch,
});
